import { useTable } from "react-table";
import { useMemo, useState, useContext } from "react";
import { RequestLoader } from "../../../hooks/context";
import {
  getSettlementAccounts,
  deleteSettlementAccount,
} from "../../../services/settlements";
import { useEffect } from "react";

const useSettlementsTableLogic = (setHasAccount) => {
  const [isFetchingAccounts, setIsFetchingAccounts] = useState(false);
  const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false);
  const [isOpenSettlementForm, setIsOpenSettlementForm] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [isDeletingAccount, setIsDeletingAccount] = useState(false);
  const [isOpenEditDialog, setIsOpenEditDialog] = useState(false);
  const { setRequestLoaderProgress } = useContext(RequestLoader);

  useEffect(() => {
    handleFetchSettlementAccounts();
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "SN",
        accessor: "id",
        Cell: ({ cell: { row } }) => row.index + 1,
      },
      {
        Header: "Bank Name",
        accessor: "bank_name",
      },
      {
        Header: "Account Number",
        accessor: "decrypted_nuban",
      },
      {
        Header: "Account Name",
        accessor: "account_name",
      },
      {
        Header: "Currency",
        accessor: "currency",
      },
      {
        Header: "Business SubAccount",
        accessor: "businesses",
        Cell: ({ cell: { value } }) => <span>{value?.[0]?.tag}</span>,
      },

      {
        Header: "Actions",
        accessor: "delete",
        Cell: ({ cell: { row } }) => (
          <span className="d-flex" style={{ gap: "10px" }}>
            <span
              onClick={() => {
                setSelectedAccount(row.original);
                setIsOpenDeleteDialog(true);
              }}
              style={{
                backgroundColor: "#E02020",
                display: "inline-block",
                padding: "10px 16px",
                fontSize: "12px",
                borderRadius: "8px",
                color: "white",
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              Delete
            </span>
            <span
              onClick={() => {
                setIsOpenEditDialog(true);
                setSelectedAccount(row.original);
              }}
              style={{
                backgroundColor: "#7647EE",
                display: "inline-block",
                padding: "10px 16px",
                fontSize: "12px",
                borderRadius: "8px",
                color: "white",
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              Edit
            </span>
          </span>
        ),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: accountList });

  const handleFetchSettlementAccounts = () => {
    setIsFetchingAccounts(true);
    setRequestLoaderProgress(40);

    getSettlementAccounts()
      .then((response) => {
        setRequestLoaderProgress(100);
        setIsFetchingAccounts(false);
        setAccountList(response.data?.data);
        if (response.data?.data.length >= 1) {
          setHasAccount(true);
        }

        if (response.data?.data.length <= 0)
          return setIsOpenSettlementForm(true);
      })
      .catch((error) => {
        setRequestLoaderProgress(100);
        setIsFetchingAccounts(false);
      });
  };

  const handleDeleteSettlementAccount = () => {
    if (selectedAccount === null) return;
    const { id } = selectedAccount;

    setIsDeletingAccount(true);
    setRequestLoaderProgress(40);

    deleteSettlementAccount(id)
      .then(() => {
        handleFetchSettlementAccounts();
        setIsDeletingAccount(false);
        setRequestLoaderProgress(100);
        setIsOpenDeleteDialog(false);
      })
      .catch((error) => {
        setRequestLoaderProgress(100);
        setIsDeletingAccount(false);
      });
  };

  return {
    instance,
    isFetchingAccounts,
    accountList,
    isOpenDeleteDialog,
    isDeletingAccount,
    selectedAccount,
    isOpenEditDialog,
    isOpenSettlementForm,
    setSelectedAccount,
    setIsOpenSettlementForm,
    setIsOpenEditDialog,
    setIsOpenDeleteDialog,
    handleDeleteSettlementAccount,
    handleFetchSettlementAccounts,
  };
};

export default useSettlementsTableLogic;
